import SceneObjectData from "../sceneObjectData/SceneObjectData";
import SceneObjectTypeEnum from "../sceneObjectData/SceneObjectTypeEnum";
import ISceneObject from "./ISceneObject";
import SceneObject, { registerSceneObjectFactory } from "./SceneObject";
import LengthDimensionSceneObject from "./LengthDimensionSceneObject";
import LengthDimensionData from "../sceneObjectData/LengthDimensionData";
import TextAnnotationSceneObject from "./TextAnnotationSceneObject";
import TextAnnotationData from "../sceneObjectData/TextAnnotationData";
import ChecklistItemSceneObject from "./ChecklistItemSceneObject";
import ChecklistItemData from "../sceneObjectData/ChecklistItemData";
import AreaAnnotationSceneObject from "./AreaAnnotationSceneObject";
import AreaAnnotationData from "../sceneObjectData/AreaAnnotationData";
import RectangleAnnotationSceneObject from "./RectangleAnnotationSceneObject";
import RectangleAnnotationData from "../sceneObjectData/RectangleAnnotationData";
import CircleAnnotationSceneObject from "./CircleAnnotationSceneObject";
import CircleAnnotationData from "../sceneObjectData/CircleAnnotationData";

const createSceneObject = (dto: SceneObjectData): ISceneObject => {
    const data = dto.clone();
    switch (data.type) {
        case SceneObjectTypeEnum.LengthDimension:
            return new LengthDimensionSceneObject(data as LengthDimensionData);
        case SceneObjectTypeEnum.TextAnnotation:
            return new TextAnnotationSceneObject(data as TextAnnotationData);
        case SceneObjectTypeEnum.ChecklistItem:
            return new ChecklistItemSceneObject(data as ChecklistItemData);
        case SceneObjectTypeEnum.AreaAnnotation:
            return new AreaAnnotationSceneObject(data as AreaAnnotationData);
        case SceneObjectTypeEnum.RectangleAnnotation:
            return new RectangleAnnotationSceneObject(data as RectangleAnnotationData);
        case SceneObjectTypeEnum.CircleAnnotation:
            return new CircleAnnotationSceneObject(data as CircleAnnotationData);
        default:
            return new SceneObject(data);
    }
};

registerSceneObjectFactory(createSceneObject);

export default createSceneObject;